import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=2c070262&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"
import style0 from "./LoginAdmin.vue?vue&type=style&index=0&id=2c070262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c070262",
  null
  
)

export default component.exports